import { STATEPATH } from './DrawerConstants';
import { get } from 'lodash';
import { DrawerReducerState } from './types';

const getLocalState = (state: DrawerReducerState) => get(state, STATEPATH);

export const isAdverseActionDrawerOpen = (state: DrawerReducerState) => getLocalState(state)?.isAdverseActionDrawerOpen;
export const adverseActionDetails = (state: DrawerReducerState) => getLocalState(state)?.adverseActionDetails;
